import React from 'react';

interface PageHeaderProps {
  title: string;
  image: string;
  className?: string;
}

export function PageHeader({ title, image, className = '' }: PageHeaderProps) {
  return (
    <div className={`relative h-[400px] ${className}`}>
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
        <h1 className="text-5xl font-playfair text-white text-center">
          {title}
        </h1>
      </div>
    </div>
  );
}